import styled from 'styled-components';

import { ResizableTextarea } from '@r1-frontend/ui-react/experimental/forms';

export const Block = styled.div`
    display: block;
    width: 100%;
    
    ${ResizableTextarea} {
        width: 100%;
    }
`;
